import React from "react";
import NeoCountDown from "./neoCountDown";
import NeoRank from "./neoRank";
import NeoEta from "./neoEta";
import { StandaloneLoader } from './neoLoader';

export default function NeoQueue({ spin=true, token, waitingTime, step, onLeave }) {
    // Recover specific wording for queue
    const { data: { queue: { wording }}} = step;

    let { rank, eta, display_rank=true, display_eta=true, display_next_update=true, next_in_line_threshold=2 }= step.data;
    return (
        <div className="queue-panel" >
            <hr className={"queue-divider"} />
            <div>
                <div className={`queue-spinner ${display_rank ? 'rank' : 'standalone'}`}>
                     <StandaloneLoader className="neo-loader"/>
                </div>
                {
                    display_rank &&
                    <NeoRank token={token} next={next_in_line_threshold} wording={wording} rank={rank} />
                }
                {
                    display_eta &&
                    <NeoEta waitingTime={eta} wording={wording} className="queue-waiting-eta" />
                }
                {
                    display_next_update &&
                    <NeoCountDown waitingTime={waitingTime} wording={wording} className="queue-count-down" onLeave={onLeave} canLeave={true} />
                }
            </div>
        </div>
    );
}
